<template>
    <div class="loading-content-container">
        <div v-if="loading" class="loading-overlay d-flex justify-content-center pt-5">
            <csp-loading-indicator/>
        </div>

        <b-row v-if="!loading">
            <csp-desktop-info-card
                :cols="12"
                icon="inticon-users"
                :show-buttons="false"
                title="Benutzerzuweisung">
                <div class="mb-5">
                    <h1>Benutzer in der Firmengruppe {{ firmGroupName }}</h1>
                    <p>
                        Benutzer mit angehakter Checkbox erhalten Filialzugriff für die Filiale
                        <b>{{ currentFirmName }}</b>
                    </p>
                </div>

                <b-form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-md-3 mb-5">
                            <h2>{{ currentFirmName }}</h2>

                            <b-form-group
                                v-for="(user, index) in currentFirmUsers"
                                :key="'current-user-' + index">
                                <b-form-checkbox :checked="true" disabled>
                                    {{ user }}
                                </b-form-checkbox>
                            </b-form-group>

                            <p v-if="currentFirmUsers.length === 0">
                                keine Benutzer vorhanden für diesen Stammbetrieb
                            </p>
                        </div>

                        <div
                            v-for="(firm, firmIndex) in otherFirms"
                            :key="'firm-' + firmIndex"
                            class="col-md-3 mb-5">
                            <h2>{{ firm.firmName }}</h2>

                            <div v-if="firm.users.length > 0" class="mb-2">
                                <b-button variant="primary" @click="checkAllUsersInFirm(firmIndex)">
                                    alle auswählen
                                </b-button>
                                <b-button variant="primary" @click="uncheckAllUsersInFirm(firmIndex)">
                                    alle abwählen
                                </b-button>
                            </div>

                            <b-form-group
                                v-for="(user, userIndex) in firm.users"
                                :key="'user-' + firmIndex + '-' + userIndex">
                                <b-form-checkbox
                                    v-model="assignmentsForm[String(user.userId)]"
                                    :disabled="!canEdit">
                                    <span :class="user.highlight ? 'firm-branch-user-assignment-highlight' : ''">
                                        {{ user.label }}
                                    </span>
                                </b-form-checkbox>
                            </b-form-group>

                            <p v-if="firm.users.length === 0">
                                keine Benutzer vorhanden für diesen Stammbetrieb
                            </p>
                        </div>
                    </div>

                    <div v-if="canEdit" class="mt-3">
                        <csp-form-group-btn-submit
                            :disable="!canEdit"
                            :is-loading="saving"
                            @click="submit"/>
                    </div>
                </b-form>
            </csp-desktop-info-card>
        </b-row>
    </div>
</template>

<script>
    import Container from '@services/Container';

    export default {
        name: 'FirmBranchUserAssignment',
        provide() {
            return {
                emitFieldChange: () => {},
            };
        },
        props: {
            firmId: {
                type: [String, Number],
                required: true,
            },
        },
        data() {
            return {
                loading: true,
                saving: false,
                firmGroupName: '',
                currentFirmName: '',
                currentFirmUsers: [],
                otherFirms: [],
                otherFirmUserIdsMap: {},
                assignmentsForm: {},
                canEdit: false,
            };
        },
        mounted() {
            const container = Container.getInstance();
            this.firmRepository = container.getDesktopFirmRepository();
            this.flashMessenger = container.getFlashMessenger();

            this.loadData();
        },
        methods: {
            checkAllUsersInFirm(firmIndex) {
                const userIds = this.otherFirmUserIdsMap[firmIndex] ?? [];

                userIds.forEach((userId) => {
                    this.$set(this.assignmentsForm, userId, true);
                });
            },
            uncheckAllUsersInFirm(firmIndex) {
                const userIds = this.otherFirmUserIdsMap[firmIndex] ?? [];

                userIds.forEach((userId) => {
                    this.$set(this.assignmentsForm, userId, false);
                });
            },
            initializeForm() {
                const formData = {};
                this.otherFirmUserIdsMap = {};

                this.otherFirms.forEach((firm, firmIndex) => {
                    this.otherFirmUserIdsMap[firmIndex] = [];

                    firm.users.forEach((user) => {
                        const userId = String(user.userId);
                        formData[userId] = user.hasBranchAccess;
                        this.otherFirmUserIdsMap[firmIndex].push(userId);
                    });
                });

                this.assignmentsForm = formData;
            },
            loadData() {
                this.loading = true;

                this.firmRepository.loadFirmBranchUserAssignments(this.firmId).then(
                    (response) => {
                        const attributes = response.data.attributes;

                        this.firmGroupName = attributes.firmGroupName;
                        this.currentFirmName = attributes.currentFirm.firmName;
                        this.currentFirmUsers = attributes.currentFirm.users ?? [];
                        this.otherFirms = attributes.otherFirms ?? [];
                        this.canEdit = response.data.meta.permissions?.canEdit === true;

                        this.initializeForm();
                        this.loading = false;
                    },
                    () => {
                        this.flashMessenger.addError(
                            'Die Daten für die Benutzerzuweisung konnten nicht geladen werden'
                        );
                        this.loading = false;
                    }
                );
            },
            submit() {
                if (!this.canEdit || this.saving) {
                    return;
                }

                this.saving = true;

                this.firmRepository.saveFirmBranchUserAssignments(
                    this.firmId,
                    {userAssignments: this.assignmentsForm}
                ).then(
                    () => {
                        this.flashMessenger.addSuccess(
                            'Die Benutzerzuweisungen wurden erfolgreich aktualisiert.'
                        );
                        this.loadData();
                    },
                    () => {
                        this.flashMessenger.addError(
                            'Fehler beim Speichern der Benutzerzuweisungen'
                        );
                    }
                ).finally(() => {
                    this.saving = false;
                });
            },
        },
    };
</script>
